
import { mapGetters } from 'vuex'
import LoleModal from '~/components/modal/lole-modal'
import LoleSizeGuide from '~/components/size-guide/lole-size-guide'
export default {
  components: { LoleModal, LoleSizeGuide },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    selectedSize: {
      type: Object,
      default: () => {},
    },
    noSelectedSize: {
      type: Boolean,
      default: false,
    },
    gender: {
      type: String,
      default: 'women',
    },
  },
  data() {
    return {
      openSizeGuide: false,
      openSizeGuideMobile: false,
    }
  },
  computed: {
    ...mapGetters({
      wordingSizeGuide: 'common/getSizeGuide',
    }),
    isMobile() {
      return !this.$store.getters['responsive/getIsWindowLarge']
    },
    openSizeGuideAt() {
      if (!this.gender) return 0
      if (this.gender === 'men') return 1
      if (this.gender === 'pets') return 2
      return 0
    },
    isLowQuantity() {
      return this.selectedSize?.quantity <= 5
        ? `-  ${this.wording?.buy_box_size_left.replace(
            'X',
            this.selectedSize?.quantity
          )}`
        : false
    },
  },
  methods: {
    toggleSizeGuide() {
      this.openSizeGuide = !this.openSizeGuide
      if (this.openSizeGuide) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    toggleSizeGuideMobile() {
      this.openSizeGuideMobile = !this.openSizeGuideMobile
      if (this.openSizeGuideMobile) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
  },
}
